module.exports = __webpack_public_path__ + "static/media/blob-shape.3326b2a0.svg";